import * as React from "react";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Rating } from "@progress/kendo-react-inputs";
import { Hint, Error, Label } from "@progress/kendo-react-labels";
import { CgDanger } from "react-icons/cg";
import IconComponent from "../common/IconComponent";

interface FormRatingProps extends FieldRenderProps {
  label?: string;
  id?: string;
  disabled?: boolean;
  hint?: string;
  optional?: boolean;
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
  fieldClassName?: string;
  astrike?: boolean;
  ratingStyle?: React.CSSProperties;
  showLabel?: boolean;
}

const FormRatingField = (props: FormRatingProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid, // Now comes directly from FieldRenderProps as required boolean
    disabled,
    hint,
    optional,
    wrapperClassName,
    wrapperStyle,
    fieldClassName,
    astrike = false,
    ratingStyle = { color: "red" },
    showLabel = true,
    ...others
  } = props;

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper className={wrapperClassName} style={wrapperStyle}>
      {showLabel && label && (
        <Label
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
          optional={optional}
        >
          {label} {astrike && <span style={{ color: "red" }}>*</span>}
        </Label>
      )}

      <Rating
        className={fieldClassName}
        valid={valid}
        disabled={disabled}
        style={ratingStyle}
        aria-describedby={`${hintId} ${errorId}`}
        {...others}
      />

      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && (
        <Error className="d-flex justify-content-end" id={errorId}>
          <span
            className="d-flex align-items-center"
            style={{
              background: "#DF4957",
              color: "white",
              padding: "1px 8px 1px 5px",
              borderRadius: 10,
              gap: 5,
            }}
          >
            <IconComponent icon={CgDanger} /> {validationMessage}
          </span>
        </Error>
      )}
    </FieldWrapper>
  );
};

export default FormRatingField;
